export default {
      id: "icon-chevron-usage",
      viewBox: "0 0 14.413 7.913",
      url: __webpack_public_path__ + "img/icons.svg#icon-chevron",
      toString: function () {
        return this.url;
      }
    }